module.exports = __webpack_public_path__ + "static/gb_3d-bdc6c40d5b3f9527cbf4209d75e73c59.png";